import { UserApi } from "apis";
import { EXCLUDED_REVIEWER } from "constants/config.constant";
import { UserStatusType } from "enums/user";
import { User } from "types/user";

const UserService = {
  getByToken: async () => {
    const result = await UserApi.getByToken();
    return result;
  },

  search: async (
    searchText: string,
    userStatus?: UserStatusType,
  ): Promise<User[]> => {
    const users = await UserApi.search(searchText, userStatus);
    return users;
  },

  getUserProfileById: async (id: number) => {
    const result = await UserApi.getUserProfileById(id);
    return result;
  },

  getActiveMembers: async (): Promise<User[]> => {
    const users = await UserApi.getAll();
    return users
      .filter(
        (user) =>
          user.status === UserStatusType.ACTIVE &&
          !EXCLUDED_REVIEWER.includes(user.email),
      )
      .sort((left, right) => left.fullName.localeCompare(right.fullName));
  },
};

export default UserService;
